<template>
  <div>
    <h1>Simple Test Page</h1>
    <p>If you can see this, Nuxt routing is working.</p>
  </div>
</template>

<script setup>
// Simple test page
</script>
